/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tools_Nexata_Feedback_List_ErrorInputs */

const es_tools_nexata_feedback_list_error = /** @type {(inputs: Tools_Nexata_Feedback_List_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al cargar feedback`)
};

const en_tools_nexata_feedback_list_error = /** @type {(inputs: Tools_Nexata_Feedback_List_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error loading feedback`)
};

/**
* | output |
* | --- |
* | "Error loading feedback" |
*
* @param {Tools_Nexata_Feedback_List_ErrorInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tools_nexata_feedback_list_error = /** @type {((inputs?: Tools_Nexata_Feedback_List_ErrorInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tools_Nexata_Feedback_List_ErrorInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tools_nexata_feedback_list_error(inputs)
	return en_tools_nexata_feedback_list_error(inputs)
});
export { tools_nexata_feedback_list_error as "tools.nexata.feedback_list_error" }